import React from 'react';
import { LinkedInCallback } from 'react-linkedin-login-oauth2';
import { Navigate, Route, Routes } from 'react-router-dom';
import { lazyWithRetry } from '../utils/lazyWithRetry';

import { VAR_ADMIN, VAR_CAMPAIGN, VAR_CRM, VAR_DASHBOARD, VAR_LEVEL, VAR_LOGIN, VAR_TEACHER, VAR_SALES_NAV, VAR_TREE, VAR_SURFER } from '../constants/textVariable';

const ErrorPage             = lazyWithRetry(() => import('../pages/NotFound'));
const Dash                  = lazyWithRetry(() => import('../pages/AureliaDashB'));
const Information           = lazyWithRetry(() => import('../pages/Information'));
const PageChecker           = lazyWithRetry(() => import('../pages/LoadingPageChecker'));
const DashRedirection       = lazyWithRetry(() => import('../pages/UserModelPage/AurDashRedPage'));
const WelcomePage           = lazyWithRetry(() => import('../pages/Accueil/WelcomingPage'));
const CodeVerificationPage2 = lazyWithRetry(() => import('../pages/Login/CodeVerificationVIew2'));
const AdminPage             = lazyWithRetry(() => import('../pages/Administration/AdminPage'));
const SalesNavigatorAccounts = lazyWithRetry(() => import('../pages/Administration/SalesNavigator/SalesNavigatorAccounts'));
const DgraphTreeView         = lazyWithRetry(() => import('../pages/Administration/DgraphTree/DgraphTreeView'));
const SurferPage             = lazyWithRetry(() => import('../features/surfer/SurferPage'));
const AutonomousTemplatePage = lazyWithRetry(() => import('../features/autonomous/pages/AutonomousTemplatePage'));
const AgentSignalsPage       = lazyWithRetry(() => import('../features/autonomous/pages/AgentSignalsPage'));
const AgentSourcesPage       = lazyWithRetry(() => import('../features/autonomous/pages/AgentSourcesPage'));
const AgentAssistantPage     = lazyWithRetry(() => import('../features/autonomous/pages/AgentAssistantPage'));

const AdminConfiguration = lazyWithRetry(() => import('../pages/Administration/dashboard/AdminSpaceConfiguration'));
const CampaignManager    = lazyWithRetry(() => import('../pages/Administration/manager/CampaignManager'));
const UserManagement     = lazyWithRetry(() => import('../pages/Administration/utilisateur/UserManagement'));
const AdminSubscription  = lazyWithRetry(() => import('../pages/Administration/AdminSubscription'));
const AccountsAdmin      = lazyWithRetry(() => import('../features/accounts/AccountsAdmin'));
const ContactsAdmin      = lazyWithRetry(() => import('../features/contacts/ContactsAdmin'));

const CGU             = lazyWithRetry(() => import('../components/Layout/CGU'));
const Confidentialite = lazyWithRetry(() => import('../components/Confidentialite'));

const SubscriptionSuccess = lazyWithRetry(() => import('../pages/SubscriptionSuccess'));
const SubscriptionCancel  = lazyWithRetry(() => import('../pages/SubscriptionCancel'));

const AllRoutes: React.FC = () => {
  return (
    <Routes>
      <Route path="/"         element={<PageChecker />} />
      <Route path="*"         element={<ErrorPage />} />
      <Route path="/error"    element={<ErrorPage />} />
      <Route path="/welcoming" element={<WelcomePage />} />
      <Route path="/info/:model_name" element={<Information />} />
      <Route path={`/:model_name/${VAR_DASHBOARD}/:page_name/:id/`}          element={<Dash />} />
      <Route path={`/:model_name/${VAR_DASHBOARD}/:page_name/:id/:mail_id/`} element={<Dash />} />
      <Route path={`/:model_name/${VAR_CAMPAIGN}/:page_name/:id/`}           element={<Dash />} />
      <Route path={`/:model_name/${VAR_TEACHER}/:page_name/:id/`}            element={<Dash />} />
      <Route path={`/:model_name/${VAR_LEVEL}/:page_name/:id/`}              element={<Dash />} />
      <Route path={`/:model_name/${VAR_CRM}/:page_name/:id/`}                element={<Dash />} />
      <Route path={`${VAR_LOGIN}`}    element={<PageChecker />} />
      <Route path="/linkedin" element={<LinkedInCallback />} />
      <Route path="/code"     element={<CodeVerificationPage2 />} />
      <Route path="/cancel"   element={<DashRedirection url_route="Tarifs" />} />

      <Route path="/subscription/success" element={<SubscriptionSuccess />} />
      <Route path="/subscription/cancel"  element={<SubscriptionCancel />} />

      <Route path="/cgu"            element={<CGU />} />
      <Route path="/confidentialite" element={<Confidentialite />} />

      <Route path={`/${VAR_SURFER}`}  element={<SurferPage />} />
      <Route path="/agent/template" element={<AutonomousTemplatePage />} />
      <Route path="/agent/signaux" element={<AgentSignalsPage />} />
      <Route path="/agent/sources" element={<AgentSourcesPage />} />
      <Route path="/agent/assistant" element={<AgentAssistantPage />} />

      <Route path={`/${VAR_ADMIN}`} element={<AdminPage />}>
        <Route index element={<AdminConfiguration />} />
        <Route path="staff" element={<UserManagement />} />
        <Route path="campaigns" element={<CampaignManager />} />
        <Route path="subscription" element={<AdminSubscription />} />
        <Route path="comptes" element={<AccountsAdmin />} />
        <Route path="contacts" element={<ContactsAdmin />} />
        <Route path={VAR_SALES_NAV} element={<SalesNavigatorAccounts />} />
        <Route path={VAR_TREE} element={<DgraphTreeView />} />
        {/* Le Surfer n'est plus dans l'espace admin : ancien lien redirigé */}
        <Route path={VAR_SURFER} element={<Navigate to={`/${VAR_SURFER}`} replace />} />
      </Route>
    </Routes>
  );
};

export default AllRoutes;